import axios from 'axios';
import { Dispatch } from 'react';
import { BASE_URL } from '../../../../config/environmentConfig';
import { merchantActionTypes } from '../action-types';
import { IAction } from '../merchant-interfaces';
import { ISiteFormProps, SiteTypes } from '../../../constants/sites/site-form';
import { sendSentryMessage } from '../../../utils/sentry-helper';
import * as Sentry from '@sentry/react';
import { getFormattedValidationFormFields } from '../../../constants/sense-js/sense-js-validation-form';
import { REQUEST_RESULT } from '../../../components/developers/sites/SenseJS';
import { errorHandler } from '../../../utils/newApplicationUtils';
import * as React from 'react';
import { GET } from '../../store-helper';

export const fetchMerchantSites = async (dispatch: Dispatch<IAction>, id: string): Promise<void> => {
	try {
		dispatch({ type: merchantActionTypes.START_SITES_LIST_LOADING });

		const data = await GET({ pathname: `${BASE_URL.MERCHANTS}/Merchant/${id}/sites` });

		dispatch({ type: merchantActionTypes.FETCH_SITES_LIST, payload: data ?? [] });
	} catch (e) {
		Sentry.setTag('fetch-sites-id', id);
		sendSentryMessage({ name: `GET Fetch merchants sites error`, context: e });
		console.log(e);
		dispatch({ type: merchantActionTypes.FETCH_FAIL });
	}
};

export const removeSite = async (merchantId: string, siteId: string): Promise<void> => {
	try {
		await axios.delete(`${BASE_URL.MERCHANTS}/Merchant/${merchantId}/sites/${siteId}`);
	} catch (e) {
		Sentry.setTag('remove-site-id', siteId);
		Sentry.setTag('remove-site-mid', merchantId);
		sendSentryMessage({ name: `DELETE Remove site error`, context: e });
		console.log(e);
	}
};

export const editSite = async (merchantId: string, siteId: string, params: ISiteFormProps, formik): Promise<void> => {
	try {
		await axios.put(`${BASE_URL.MERCHANTS}/Merchant/${merchantId}/sites/${siteId}`, params);
	} catch (e) {
		Sentry.setTag('edit-site-id', siteId);
		Sentry.setTag('edit-site-mid', merchantId);
		sendSentryMessage({ name: `PUT Edit site error`, context: e });
		console.log('editSite', e);
		errorHandler({ e, formik });
		throw new Error(e.response);
	}
};

export const addSite = async (merchantId: string, params: SiteTypes, formik): Promise<void> => {
	try {
		await axios.post(`${BASE_URL.MERCHANTS}/Merchant/${merchantId}/sites`, params);
	} catch (e) {
		Sentry.setTag('add-site-mid', merchantId);
		sendSentryMessage({ name: `POST Add site error`, context: e });
		console.log('addSite', e);
		errorHandler({ e, formik });
		throw new Error(e.response);
	}
};

export const checkWidgetValidation = async (
	dispatch: React.Dispatch<IAction>,
	formik: any,
	mid: string,
	siteId: string,
	closeModal: () => void,
	responseModal: (value?: REQUEST_RESULT ) => void
): Promise<void> => {
	try {
		dispatch({ type: merchantActionTypes.START_SENSE_JS_VALIDATION_LOADING });
		if (!formik.isValid) return;
		const { url } = getFormattedValidationFormFields(formik.values);
		const params = {
			url,
			mid,
			siteId
		};

		const res = await axios.post(`${BASE_URL.MERCHANTS}/Merchant/widget-validation`, params);
		const payload = res?.data?.isSenseJsExists ? REQUEST_RESULT.SUCCESS : REQUEST_RESULT.NOT_FOUND;
		dispatch({ type: merchantActionTypes.GET_SENSE_JS_VALIDATION_RESULT, payload });
		closeModal();
		responseModal(payload);
	} catch (e) {
		sendSentryMessage({ name: `POST widget validation error`, context: e });
		console.log('e', e.response);
		dispatch({ type: merchantActionTypes.FETCH_FAIL });
		closeModal();
		const payload = e.response?.data === `Site can't be reached` ? REQUEST_RESULT.SITE_CAN_NOT_REACH : REQUEST_RESULT.SITE_NOT_FOUND;
		responseModal(payload);
	}
};
